import BusinessMasterPage from './BusinessMasterPage';

export default BusinessMasterPage;
